// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__grAXF","isVisible":"subtitle_isVisible__UCA06","hide":"subtitle_hide__43Jff"};